export default [
  { title: "Request a signature by email (remote signing)", icon: "", link: "/docs/request-signature-email" },
  { title: "Request a signature through your app (embedded signing)", icon: "", link: "/docs/request-signature-embed" },
  { title: "Request a signature by email using a template", icon: "", link: "/docs/request-signature-template" },
  { title: "Request a signature through your app using a composite", icon: "", link: "/docs/request-signature-through" },
  { title: "Request a signature by SMS", icon: "", link: "/docs/request-signature-sms" },
  { title: "Send a request for payment", icon: "", link: "/docs/request-signature-payment" },
];
